module.exports = __webpack_public_path__ + "img/scrollto.5ae28642.svg";